<template>
    <rkm-modal
        persistent
        ref="Modal"
        title="FAA eletrônica (Paciente em observação)"
    >
        <rkm-form-checkbox
            v-if="atendimentos.length > 1"
            v-model="selectAll"
        >
            Todos
        </rkm-form-checkbox>

        <rkm-form-checkbox-group
            :options="atendimentos"
            stacked
            v-model="atendimentosSelected"
        />

        <template #footer>
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="atendimentosSelected.length === 0"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    data: () => ({
        selectAll: false,
        atendimentosSelected: []
    }),
    methods: {
        open() {

            this.atendimentosSelected = []
            this.selectAll = false

            this.$refs.Modal.show()
        },
        save() {

            const atendimentos = this.atendimentos
                .filter(a => this.atendimentosSelected.includes(a.value))
                .map(a => ({ tipo: a.tipo, id: a.id }))

            this.$emit('save', atendimentos)
            this.close()
        },
        cancel() {

            this.$emit('cancel')
            this.close()
        },
        close() {

            this.$refs.Modal.hide()
        }
    },
    props: {
        atendimentos: { type: Array, required: true }
    },
    watch: {
       'selectAll': function (selectAll) {

            this.atendimentosSelected = selectAll
                ? this.atendimentos.map(a => a.value)
                : []
        },
    }
}
</script>